import { render, staticRenderFns } from "./coffoffsetdata.vue?vue&type=template&id=4c355780&scoped=true&"
import script from "./coffoffsetdata.vue?vue&type=script&lang=js&"
export * from "./coffoffsetdata.vue?vue&type=script&lang=js&"
import style0 from "./coffoffsetdata.vue?vue&type=style&index=0&id=4c355780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c355780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDialog,VEditDialog,VIcon,VSimpleTable,VSpacer,VTextField,VToolbar,VToolbarItems,VToolbarTitle})
